import React, { useState, useEffect } from 'react';
import { Col, Row, Input, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab'


// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import Loading from '../../../components/modales/loadingModal';

//API Calls
const { apiListadoContratos } = require('../../../utils/APIs/APISResume')

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalEnvioProrrogas = (props) => {
    let todayDate = new Date(Date.now())
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [loading, setLoading] = useState(true);
    const [listaContratos, setListaContratos] = useState([])
    const [startDate, setStartDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth(), 1))
    const [endDate, setEndDate] = useState(new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 1))
    const [gerencia, setGerencia] = useState(userData.gerencia)
    const [ok, setOk] = useState(true)
    useEffect(() => {
        async function Lista2Contratos() {
            await ListaContratos()
        }
        Lista2Contratos()
    }, [])

    const ListaContratos = async () => {
        try {
            const request = await apiListadoContratos({ cod_empr: 537 });
            if (userData.roles.includes('administrador') || userData.roles.includes('contratador')) setListaContratos([{ cod_tnom: 0, nom_tnom: 'Todos' }, ...request])
            else setListaContratos([...request]);
            setLoading(false)
        }
        catch (error) {
            setLoading(false)
            console.log('error', error)
        }
    }

    const returnInputGerencia = () => {
        return (
            <Col lg='4' md='4' xs="12">
                <Autocomplete
                    required
                    margin="dense"
                    // options={userData.roles.includes('administrador') ? [, ...listaContratos] : listaContratos}
                    options={listaContratos}
                    key={`key_TipoDeContrato`}
                    id={`select_TipoDeContrato`}
                    onChange={(event, newValue) => setGerencia(newValue)}
                    renderInput={(params) => (
                        <TextField {...params} label={'CONTRATO'} margin="normal" />
                    )}
                    getOptionLabel={(option) => option.nom_tnom}
                    renderOption={(option) => (
                        <React.Fragment>
                            {option.nom_tnom}
                        </React.Fragment>
                    )}
                />
            </Col>
        )
    }
    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Exportar Reporte'}
                buttonTitle={'Enviar'}
                enableOk={ok}
                onClick={() => props.action({ start: startDate.toISOString().split('T')[0], end: endDate.toISOString().split('T')[0], gerencia: gerencia.cod_tnom })}
            // buttonLoading={cancelando}
            >
                {loading ? <Loading /> : <Row>
                    {returnInputGerencia()}
                    <Col lg='4' md='4' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Inicio</Label>
                        <Input
                            id="startDate"
                            name="datetime"
                            value={startDate ? startDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => setStartDate(new Date(e.target.value))}
                            type="date"
                        />
                    </Col>
                    <Col lg='4' md='4' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Fin</Label>
                        <Input
                            id="endDate"
                            name="datetime"
                            value={endDate ? endDate.toISOString().split('T')[0] : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => {
                                setOk(true)
                                setEndDate(new Date(e.target.value))
                            }}
                            type="date"
                        />
                    </Col>
                </Row>}
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalEnvioProrrogas);